module.exports = __webpack_public_path__ + "img/news03.5fa62a98.png";